import { doc, Firestore, updateDoc } from "firebase/firestore";

export async function updateEstateMetadata(db: Firestore, id: string, data: Record<string, any>) {
  // Membership is managed by the sharing backend, never by the estate form.
  const { users, roles, orgId, audienceActive, ...metadata } = data;
  await updateDoc(doc(db, `estates/${id}`), metadata);
}

export async function updateMapMetadata(db: Firestore, id: string, data: Record<string, any>) {
  // Firestore authorizes same-organization estate changes atomically with the edit.
  const { users, roles, orgId, audienceActive, ...metadata } = data;
  await updateDoc(doc(db, `maps/${id}`), metadata);
}
